const getWizardItems = (self) => [
  { key: 'attach-delivery', label: self.$t('routeOptimization.wizard.selectDelivery') },
  { key: 'set-parameters', label: self.$t('routeOptimization.wizard.setParameters') },
]

export default getWizardItems
